<svg width="100" height="67" viewBox="0 0 100 67" fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" y="0.5" width="99" height="66" rx="1.42593" fill="#F1F1F1"/>
  <rect x="0.5" y="0.5" width="99" height="66" rx="1.42593" stroke="#E1E1E1"/>
  <g clip-path="url(#clip0_1301_17184)">
    <rect x="33" y="16" width="35" height="35" rx="17.5" fill="white"/>
    <rect width="35" height="35" transform="translate(33 16)" fill="#E1E1E1"/>
    <path d="M50.4999 22.9031C53.7137 22.9031 56.2847 25.4741 56.2847 28.6879C56.2847 31.9016 53.7137 34.4726 50.4999 34.4726C47.2862 34.4726 44.7151 31.9016 44.7151 28.6879C44.7151 25.4741 47.2862 22.9031 50.4999 22.9031ZM50.4999 47.3277C46.2417 47.3277 42.3852 45.3994 39.8141 42.4267C41.3407 39.936 43.992 38.3292 47.0451 38.3292H53.9547C57.0078 38.3292 59.6591 39.936 61.1857 42.4267C58.6147 45.3994 54.7582 47.3277 50.4999 47.3277Z" fill="#B5B5B5"/>
  </g>
  <defs>
    <clipPath id="clip0_1301_17184">
      <rect x="33" y="16" width="35" height="35" rx="17.5" fill="white"/>
    </clipPath>
  </defs>
</svg>
